export default import.meta.ROLLDOWN_FILE_URL_5wp$RNhxvUvkhGFewhr33Q